import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import Row from 'components/layout/grid/Row';
import Col from 'components/layout/grid/Col';
import InputFormAdapter from 'components/form/InputFormAdapter';
import { Validations } from 'components/form/validation-forms/Validations';
import Button from 'components/ui/button/Button';
import ApiService from 'services/ApiService';
import { toast } from 'react-toastify';
import LoaderInline from '../loader/LoaderInline';
import { Utils } from 'utils/UtilsDefault';

type Props = {
  btnText: string;
};

const NewsLetter: React.FC<Props> = ({ btnText }) => {
  const [isLoading, setIsLoading] = useState(false);

  function handleSubmit(data) {
    setIsLoading(true);
    const dados = {
      name: data.name,
      email: data.email,
    };
    Utils.saveTagManager("click_newsletter", dados);

    ApiService.conversions
      .newsletter(dados)
      .then((res: boolean) => {
        if (res) {
          toast.success('Cadastro realizado com sucesso!');
        } else {
          toast.error('Ocorreu um problema, tente novamente');
        }
        setIsLoading(false);
      })
      .catch(() => {
        toast.error('Ocorreu um problema, tente novamente');
        setIsLoading(false);
      });
  }

  return (
    <div id="NewsLetter">
      {!isLoading && (
        <Form onSubmit={handleSubmit}>
          {({ handleSubmit: Submit }) => (
            <form onSubmit={Submit} id="newsletter" name="newsletter" noValidate>
              <Row>
                <Col lg="4">
                  <Field
                    name="name"
                    component={InputFormAdapter}
                    label={{ type: 1, label: 'Nome', descricao: null }}
                    placeholder="Nome"
                    validate={Validations.required}
                    autoComplete="off"
                  />
                </Col>
                <Col lg="5" className="emailNewsLetter">
                  <Field
                    name="email"
                    component={InputFormAdapter}
                    label={{
                      type: 1,
                      label: 'E-mail',
                      descricao: null,
                    }}
                    placeholder="E-mail"
                    validate={Validations.composeValidators(
                      Validations.required,
                      Validations.validateEmail,
                    )}
                    autoComplete="off"
                    type="email"
                  />
                </Col>
                <Col lg="3">
                  <Button type="submit" className="btn-orange">
                    <span>{btnText}</span>
                  </Button>
                </Col>
              </Row>
            </form>
          )}
        </Form>
      )}
      {isLoading && <LoaderInline />}
    </div>
  );
};

export default NewsLetter;
